import Posts from "../components/Blog/Posts";

function HistoryPage() {
	return (
		<main>
			<div className="container my-4">
				<Posts type="historie" />
			</div>
		</main>
	);
}
export default HistoryPage;
